module.exports = __webpack_public_path__ + "img/history.5eac9ec4.svg";